"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransactionsByType = exports.getTransactionHistory = exports.getPendingTransactions = exports.getTransactions = exports.getTransactionsByStatus = exports.getTransaction = exports.getLoading = exports.getData = exports.getState = void 0;

var utils_1 = require("./utils");

var sortByTimestamp = function sortByTimestamp(a, b) {
  return a.timestamp > b.timestamp ? -1 : 1;
};

var getState = function getState(state) {
  return state.transaction;
};

exports.getState = getState;

var getData = function getData(state) {
  return exports.getState(state).data;
};

exports.getData = getData;

var getLoading = function getLoading(state) {
  return exports.getState(state).loading;
};

exports.getLoading = getLoading;

var getTransaction = function getTransaction(state, hash) {
  return exports.getData(state).find(function (tx) {
    return tx.hash === hash;
  });
};

exports.getTransaction = getTransaction;

var getTransactionsByStatus = function getTransactionsByStatus(state, address, status) {
  return exports.getData(state).filter(function (tx) {
    return tx.from === address && tx.status === status;
  }).sort(sortByTimestamp);
};

exports.getTransactionsByStatus = getTransactionsByStatus;

var getTransactions = function getTransactions(state, address) {
  return exports.getData(state).filter(function (tx) {
    return tx.from === address;
  }).sort(sortByTimestamp);
};

exports.getTransactions = getTransactions;

var getPendingTransactions = function getPendingTransactions(state, address) {
  return exports.getData(state).filter(function (tx) {
    return tx.from === address && utils_1.isPending(tx.status);
  }).sort(sortByTimestamp);
};

exports.getPendingTransactions = getPendingTransactions;

var getTransactionHistory = function getTransactionHistory(state, address) {
  return exports.getData(state).filter(function (tx) {
    return tx.from === address && !utils_1.isPending(tx.status);
  }).sort(sortByTimestamp);
};

exports.getTransactionHistory = getTransactionHistory;

var getTransactionsByType = function getTransactionsByType(state, address, type) {
  return exports.getData(state).filter(function (tx) {
    return tx.from === address && tx.actionType === type;
  }).sort(sortByTimestamp);
};

exports.getTransactionsByType = getTransactionsByType;